export default {
  LOGGED_USER_KEY: 'local-storage-_auth_.content',
  AUTH_TOKEN_KEY: 'local-storage-_auth_.token',
  WORKSPACE_KEY: 'local-storage-_auth_.workspace',
  PERMISSIONS_KEY: 'local-storage-_auth_.permissions',
  LOCALE_KEY: 'local-storage-_language_._language_selected',
  PROJECT_ID: 'local-storage-_project_.project_id',
  LAST_CAMPAIGN_VIEW_PREFIX: 'local-storage-_campaign_.last_view',
  PDF_OPTIONS_STORAGE_KEY: 'local-storage-_pdf_options'
}
